<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="goToManageProduct()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Product Details
            </span>
        </div>
    </div>
    <div class="card card_content">
        <div class="cssmtgb just_center">
            <mat-tab-group animationDuration="1000ms" mat-stretch-tabs mat-align-tabs="start"
            (selectedTabChange)="onTabChange($event)">
                <mat-tab label="Primary Information">
                    <form [formGroup]="form">
                        <div class="row mx-5 mx-5">
                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Product Category</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="ProductCategoryType"
                                        (selectionChange)="selectPrimaryProduct()"
                                        placeholder="Select Primary Product ">
                                        <mat-select-filter [displayMember]="'value'" [array]="productlist"
                                            (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredList1" [value]="item.key"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Product Sub Category</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="productSubCategoryId"
                                        [disabled]="!subCategoryEnabled" (selectionChange)="selectSubCategory()"
                                        placeholder="Select Primary Product ">
                                        <mat-select-filter [displayMember]="'value'" [array]="subproductlist"
                                            (filteredReturn)="filteredList2 = $event"></mat-select-filter>
                                        <ng-container *ngIf="filteredList2?.length; else noData">
                                            <mat-option *ngFor="let item of filteredList2" [value]="item.key"
                                                style="overflow-y: scroll !important;">
                                                {{ item.value }}
                                            </mat-option>
                                        </ng-container>
                                        <ng-template #noData>
                                            <mat-option disabled>
                                                No data available
                                            </mat-option>
                                        </ng-template>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mx-5" >
                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Provider Name</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="serviceProviderId"
                                        (selectionChange)="selectServiceProvider()"
                                        placeholder="Select Primary Product ">
                                        <mat-select-filter [displayMember]="'value'" [array]="serviceproviderList"
                                            (filteredReturn)="filteredList3 = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredList3" [value]="item.key"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Product Classification</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="productClassification"
                                        placeholder="Select Primary Product ">
                                        <mat-select-filter [displayMember]="'value'" [array]="ProductClassificationlist"
                                            (filteredReturn)="filteredList4 = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredList4" [value]="item.key"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mx-5 pl-2 mt-3" *ngIf="this.form.value.serviceProviderId && this.form.value.serviceProviderId==2">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <div class="col-sm-12 col-md-12 align-self-center" style="display: flex; align-items: center;">
                                    <label style="margin-right: 30px; font-size: large;">Is Nova</label>
                                    <mat-radio-group formControlName="isNova" (change)="novacheck()"
                                        style="display: flex; flex-direction: row mx-4; gap: 80px;">
                                        <mat-radio-button [value]="true">Yes</mat-radio-button>
                                        <mat-radio-button class="ml-3" [value]="false">No</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4"  *ngIf="this.form.value.isNova==false">
                                <div class="col-sm-12 col-md-12 align-self-center">
                                    <label style="margin-right: 30px; font-size: large;">Is This Product need to show in nova areas</label>
                                    <mat-radio-group formControlName="novaNetworkProd"
                                        style="display: flex; flex-direction: row mx-4; gap: 80px;">
                                        <mat-radio-button [value]="false">Yes</mat-radio-button>
                                        <mat-radio-button class="ml-3" [value]="true">No</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                        </div>
                        <div class="row mx-5 mt-3">

                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Naming Convention</mat-label>
                                    <input matInput  formControlName="aliasName"
                                        placeholder="Enter Naming Convention" class="col-10" autocomplete="off" [readonly]="this.productId!=0">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Product Name</mat-label>
                                    <input matInput  formControlName="productName"
                                        placeholder="Enter Product Name" class="col-10" autocomplete="off" [readonly]="this.productId!=0">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row mx-5">

                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Product Id</mat-label>
                                    <input matInput   formControlName="productId"
                                        placeholder="Enter Product Id" class="col-10" autocomplete="off" [readonly]="this.productId!=0">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Product Cost (Including VAT)</mat-label>
                                    <input matInput   formControlName="cost"
                                        placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>


                        <div class="row mx-5">
                            <ng-container *ngIf="this.form.value.ProductCategoryType === this.ProductCategoryTypeEnum.Voice
                            || this.form.value.ProductCategoryType === this.ProductCategoryTypeEnum.Hardware ||
                            this.form.value.ProductCategoryType === this.ProductCategoryTypeEnum.ValueAddedService">

                                <div class="col-xl-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Product Cost Type</mat-label>
                                        <mat-select class="scrollbarcs" formControlName="costType"
                                            placeholder="Select Primary Product ">
                                            <mat-select-filter [displayMember]="'value'" [array]="costTypelist"
                                                (filteredReturn)="filteredList7 = $event"></mat-select-filter>
                                            <mat-option *ngFor="let item of filteredList7" [value]="item.key"
                                                style="overflow-y: scroll !important;">
                                                {{item.value}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="subproductvalue">
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <ng-multiselect-dropdown formControlName="connectionFeeId"
                                        placeholder="Select The Connection Fee" [settings]="dropdownSettings"
                                        [data]="connectionFeelist">
                                    </ng-multiselect-dropdown>
                                </div>
                            </ng-container>

                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Comments / Specification</mat-label>
                                    <input matInput   formControlName="comments"
                                        placeholder="Enter Comments / Specification" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mx-5">
                            <ng-container *ngIf="this.form.value.ProductCategoryType===this.ProductCategoryTypeEnum.Voice
                            || this.form.value.ProductCategoryType === this.ProductCategoryTypeEnum.Hardware ||
                            this.form.value.ProductCategoryType === this.ProductCategoryTypeEnum.ValueAddedService">
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <div
                                        style="display: flex;align-items: center;">
                                        <label style="margin-right: 30px; font-size: large;">Delivery Cost
                                            Applicable?</label>
                                        <mat-checkbox formControlName="noDeliveryCost" style="transform: scale(1.3);"
                                            color="primary"></mat-checkbox>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <div class="col-sm-12 col-md-6 align-self-center"
                                        style="display: flex; justify-content: space-between; align-items: center;">
                                        <label style="margin-right: 30px; font-size: large;">Is EFT Payment?</label>
                                        <mat-checkbox formControlName="eftPayment" style="transform: scale(1.3);"
                                            color="primary"></mat-checkbox>
                                    </div>
                                </div>

                            </ng-container>

                            <ng-container *ngIf="subproductvalue && this.form.value.ProductCategoryType == 1">
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Download Speed</mat-label>
                                        <input matInput   formControlName="downloadSpeed"
                                            placeholder="Enter Download Speed" class="col-10" autocomplete="off">
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Upload Speed</mat-label>
                                        <input matInput   formControlName="uploadSpeed"
                                            placeholder="Enter your Upload Speed" class="col-10" autocomplete="off">
                                    </mat-form-field>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="subproductvalue && this.form.value.ProductCategoryType == 2">
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Download Speed</mat-label>
                                        <input matInput   formControlName="downloadSpeed"
                                            placeholder="Enter Download Speed" class="col-10" autocomplete="off">
                                    </mat-form-field>
                                </div>
                            </ng-container>
                        </div>

                        <div class="row mx-5">
                            <div class="col-xl-6 mt-4">
                                <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                    <mat-label>Start Date</mat-label>
                                    <input readonly matInput  [matDatepicker]="startDatePicker"
                                        formControlName="startOnTs" autocomplete="off" [min]="today"
                                        placeholder="Select From Date" class="custom-input-border"
                                        (dateChange)="onStartDateChange($event)" (click)="startDatePicker.open()">
                                    <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                        <button mat-icon-button>
                                            <mat-icon>event</mat-icon>
                                        </button>
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #startDatePicker></mat-datepicker>
                                </mat-form-field>
                            </div>

                            <div class="col-xl-6 mt-4">
                                <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                    <mat-label>End Date</mat-label>
                                    <input readonly matInput  [matDatepicker]="endDatePicker"
                                        formControlName="expiredOnTs" autocomplete="off" [min]="minEndDate"
                                        placeholder="Select To Date" class="custom-input-border"
                                        (click)="endDatePicker.open()">
                                    <mat-datepicker-toggle matSuffix [for]="endDatePicker" style="color:black;">
                                        <button mat-icon-button>
                                            <mat-icon>event</mat-icon>
                                        </button>
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #endDatePicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>


                        <div class="row mx-5">
                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Posting Class</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="postingClass"
                                        placeholder="Select Posting Class">
                                        <mat-select-filter [displayMember]="'value'" [array]="postingClassList"
                                            (filteredReturn)="filteredList5 = $event"></mat-select-filter>
                                        <ng-container *ngIf="filteredList5?.length; else noData1">

                                            <mat-option *ngFor="let item of filteredList5" [value]="item.key"
                                                style="overflow-y: scroll !important;">
                                                {{item.value}}
                                            </mat-option>
                                        </ng-container>
                                        <ng-template #noData1>
                                            <mat-option disabled>
                                                No data available
                                            </mat-option>
                                        </ng-template>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Item Class</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="itemClass"
                                        placeholder="Select Item Class ">
                                        <mat-select-filter [displayMember]="'value'" [array]="ItemClassList"
                                            (filteredReturn)="filteredList6 = $event">
                                        </mat-select-filter>
                                        <ng-container *ngIf="filteredList6?.length; else noData">
                                            <mat-option *ngFor="let item of filteredList6" [value]="item.key"
                                                style="overflow-y: scroll !important;">
                                                {{ item.value }}
                                            </mat-option>
                                        </ng-container>
                                        <ng-template #noData>
                                            <mat-option disabled>
                                                No data available
                                            </mat-option>
                                        </ng-template>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                        </div>

                        <div class="row mx-5">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Cost to HC</mat-label>
                                    <input matInput   formControlName="hcCost"
                                        placeholder="Enter Cost to HC" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>
                    </form>
                </mat-tab>

                <mat-tab label="Features">
                    <div class="row mt-3">
                        <div class="col-xl-2"></div>
                        <div class="col-xl-8">
                            <form [formGroup]="featureform">
                                <!-- <div class="editor">
                                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                                    </ngx-editor-menu>
                                    <ngx-editor [editor]="editor" formControlName="feature">
                                    </ngx-editor>
                                </div> -->
                                <div class="editor" style="background: white;">
                                    <quill-editor formControlName="feature" [modules]="toolbarModules"
                                        style="background: white;"></quill-editor>
                                </div>
                            </form>
                        </div>
                        <div class="col-xl-2"></div>
                    </div>
                </mat-tab>

                <mat-tab label="Logo">
                    <form [formGroup]="imgform" class="card mt-3">
                        <div class="row">
                            <div class="col-xl-3"></div>
                            <div class="col-xl-6">
                                <div class="row mt-3">
                                    <div class="col-sm-12 col-md-12 padd-right-file" style="display: flex;">
                                        <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                                            <mat-label>Product Logo</mat-label>
                                            <input matInput  id="img" placeholder="Select Attachment"
                                                formControlName="img" autocomplete="off" specialIsAlphaNumeric
                                                class="col-10" autocomplete="off" readonly>
                                        </mat-form-field>
                                        <div>
                                            <button type="button" (click)="selectFile()"
                                                class="badge bg-light-blue image-button">
                                                <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg"
                                                    style="width: 26px;" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-md-5" *ngIf="loadImageSlider.length > 0"
                                        style="position: relative; margin-top: 20px; max-width: 600px;; overflow: hidden;">
                                        <div class="image-slider">
                                            <img [src]="loadImageSlider[currentIndex].image" alt="Image Preview"
                                                style="width: 100%; height: auto;">
                                        </div>

                                        <button class="slider-arrow left-arrow" (click)="previousImage()"
                                          *ngIf="loadImageSlider.length > 1" >
                                            &#10094;
                                        </button>

                                        <button class="slider-arrow right-arrow" (click)="nextImage()"
                                        *ngIf="loadImageSlider.length > 1" >
                                            &#10095;
                                        </button>
                                    </div>

                                    <div class="col mt-3" *ngIf="loadImageSlider.length > 0">
                                        <div *ngFor="let doc of loadImageSlider; let i = index" class="row d-flex mt-3">
                                            <div class="col-xl-8">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <input type="radio" [value]="i" formControlName="defaultimgid"
                                                            (change)="onImageSelect(i,doc.imageName,doc.image)"
                                                            style="margin-right: 10px;" />

                                                        <span>{{ doc.imageName }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-4 d-flex">
                                                <!-- <button (click)="removeImage(i)" class="btn btn-primary mr-2">X
                                                </button> -->
                                                <i class="fa fa-close" (click)="removeImage(i)"
                                                    style="font-size: 20px; color: red;"></i>
                                                <i class="fa fa-eye ml-3" (click)="previewpopup(doc)"
                                                    style="font-size: 20px; color: #9a00da;"></i>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="col-xl-3">
                            </div>
                        </div>
                    </form>
                </mat-tab>

                <mat-tab label="Business">
                    <form [formGroup]="businessForm">
                        <div class="mt-5 ml-5">
                            <h2>Business Logic</h2>
                        </div>
                        <div class="container mt-4">
                            <div class="row">
                                <div class="col-12 col-md-6 mb-4">
                                    <div class="card" style="width: 100%;">
                                        <div class="card-body">
                                            <p class="card-text" style="font-size: medium;">In order to purchase this ,
                                                what other item must be included in the customer’s cart?</p>
                                            <div class="col mt-4">
                                                <mat-form-field appearance="fill" style="width: 100%;"
                                                    hideRequiredMarker>
                                                    <mat-label>Product</mat-label>
                                                    <mat-select placeholder="Select Primary Product"
                                                        formControlName="selectedMustHaveAll" multiple>
                                                        <input matInput placeholder="Search" />
                                                        <mat-optgroup *ngFor="let group of filteredGroupedProducts()"
                                                            [label]="group?.categoryName?.toUpperCase()">
                                                            <mat-option *ngFor="let product of group.products"
                                                                [value]="product.id">
                                                                {{ product?.aliasName?.toUpperCase() }} - {{
                                                                product?.productCategoryName?.toUpperCase() }}
                                                            </mat-option>
                                                        </mat-optgroup>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-md-6 mb-4">
                                    <div class="card" style="width: 100%;">
                                        <div class="card-body">
                                            <p class="card-text" style="font-size: medium;">In order to purchase this ,
                                                Customer must have either of the below Products</p>
                                            <div class="col mt-4">
                                                <mat-form-field appearance="fill" style="width: 100%;"
                                                    hideRequiredMarker>
                                                    <mat-label>Product</mat-label>
                                                    <mat-select placeholder="Select Product Name"
                                                        formControlName="selectedMustHaveAnyOne" multiple>
                                                        <input matInput placeholder="Search" />
                                                        <mat-optgroup *ngFor="let group of filteredGroupedProducts()"
                                                            [label]="group?.categoryName?.toUpperCase()">
                                                            <mat-option *ngFor="let product of group.products"
                                                                [value]="product.id">
                                                                {{ product?.aliasName?.toUpperCase() }}{{
                                                                product?.productCategoryName?.toUpperCase() }}
                                                            </mat-option>
                                                        </mat-optgroup>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>
                </mat-tab>
            </mat-tab-group>
            <div class="mt-3 d-flex justify-content-end">
                <button class="btn btn-primary mb-3 mr-3" type="button" (click)="preview()"
                   *ngIf="selectedIndex==1" matButton>Preview</button>
                <button class="btn btn-primary mb-3 mr-3" type="button" (click)="goToManageProduct()"
                    matButton>Cancel</button>
                <button class="btn btn-secondary mb-3" type="submit" (click)="save()" matButton>Save</button>
            </div>